export default __webpack_public_path__ + "static/media/fogg-teamwork.e59c5a74.png";